import React from 'react';
import { Divider, Tab, Tabs } from '@material-ui/core';
import { TabPanel } from '../../components/TabPanel.component';
import { DomainForm } from './domain.form';
import { DisplayConfigForm } from './displayConfig.form';
import { PaymentForm } from './payment.form';
import {TemplatesForm} from "./templates.form";

/**
 * Composant d'onglets pour la configuration du domaine
 * 
 * Ce composant organise la configuration du domaine en plusieurs onglets :
 * - Domaine : Configuration générale du domaine
 * - Affichage : Configuration de l'interface utilisateur
 * - Paiement : Configuration des méthodes de paiement
 * - Modèles : Configuration des templates et documents
 * 
 * Logique métier :
 * - Navigation par onglets pour organiser les paramètres
 * - État local pour gérer l'onglet actif
 * - Composants de formulaire spécialisés pour chaque section
 * - Interface utilisateur cohérente avec Material-UI
 * 
 * @returns Composant React des onglets de configuration du domaine
 */
export const DomainTabs: React.FC = () => {
  /**
   * État local pour gérer l'onglet actuellement sélectionné
   */
  const [selectedTab, setSelectedTab] = React.useState('domain');

  /**
   * Gère le changement d'onglet sélectionné
   * 
   * @param event Événement de changement d'onglet
   * @param newValue Nouvelle valeur de l'onglet sélectionné
   */
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <div>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        aria-label="Configuration du domaine"
      >
        <Tab value="domain" label="Domaine" />
        <Tab value="displayConfig" label="Affichage" />
        <Tab value="payment" label="Paiement" />
        <Tab value="templates" label="Modèles" />
      </Tabs>
      <Divider variant="middle" />
      <TabPanel value={selectedTab} index="domain">
        <DomainForm />
      </TabPanel>
      <TabPanel value={selectedTab} index="displayConfig">
        <DisplayConfigForm />
      </TabPanel>
      <TabPanel value={selectedTab} index="payment">
        <PaymentForm />
      </TabPanel>
      <TabPanel value={selectedTab} index="templates">
        <TemplatesForm />
      </TabPanel>
    </div>
  );
};
